import React, { useEffect, useState } from 'react'
import Icon from './Icon'
import ReactDOM from 'react-dom'
import useEventListener from 'core/hooks/useEventListener'

function FullscreenPopup({ children, closePopup = () => {} }) {
  const [element, setElement] = useState(null)

  useEffect(() => {
    const el = document.createElement('div')
    el.className = 'ccp-popup-container__fullscreen'

    document.body.appendChild(el)
    setElement(el)
    return () =>  document.body.removeChild(el)
  }, [])

  useEventListener('keydown', e => {
    if (e.keyCode === 27) {
      closePopup()
    }
  })

  useEventListener('click', e => {
    if (e.target.className === 'ccp-popup-container__fullscreen') {
      closePopup()
    }
  })

  if (!element) {
    return null
  }

  return ReactDOM.createPortal((
    <>
      <Icon iconName="close" onClick={closePopup}/>
      <div className="ccp-popup-content">
        {children}
      </div>
    </>
  ), element)
}

export default FullscreenPopup
